module.exports = __webpack_public_path__ + "940f7c6045718e1e1263978b6547c22f.jpg";